import { TicketPagingDto } from '@/__generated';
import { IFilterItem, IColumnType } from '@/components/ZTable';
import { dateTimeDisplayFormat, formatApiDate, formatDisplayFullDate } from '@/config';

export const PAGE_TITLE = 'Sell on the go bookings';

export const filters: Array<IFilterItem> = [
  { type: 'TEXT', name: 'BookingRefNo', label: 'ticketBooking_BookingRefNo' },
  { type: 'TEXT', name: 'ReceiptRefNo', label: 'bookingPage_ReceiptRefNo' },
  { type: 'DATE', name: 'BookingDate', label: 'ticketBooking_BookingDate', parseValue: v => formatApiDate(v) },
  { type: 'DATE', name: 'departureDate', label: 'bookingPage_DepartureDate', parseValue: v => formatApiDate(v) },
];

export const columns: IColumnType<TicketPagingDto>[] = [
  {
    title: 'ticketBooking_BookingRefNo',
    dataIndex: 'bookingRefNo',
    ellipsis: true,
    sorter: true,
    width: 150,
  },
  {
    title: 'ticketBooking_FromStation',
    dataIndex: 'sourceName',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'ticketBooking_ToStation',
    dataIndex: 'destinationName',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'tripsPage_TripName',
    dataIndex: 'tripName',
    ellipsis: true,
    width: 150,
  },
  {
    title: 'ticketBooking_Passenger',
    dataIndex: 'noOfPassengers',
    ellipsis: true,
    width: 100,
  },

  {
    title: 'bookingPage_DepartureDate',
    dataIndex: 'departureDateTime',
    width: 170,
    ellipsis: true,
    render: v => (v ? dateTimeDisplayFormat.originDateTime(v) : ''),
    sorter: true,
  },

  {
    title: 'bookingPage_ArrivalDateTime',
    dataIndex: 'arrivalDateTime',
    width: 170,
    ellipsis: true,
    render: v => (v ? dateTimeDisplayFormat.originDateTime(v) : ''),
    sorter: true,
  },
  {
    title: 'ticketBooking_BookingDate',
    dataIndex: 'bookingDate',
    width: 170,
    ellipsis: true,
    render: v => (v ? formatDisplayFullDate(v) : ''),
    sorter: true,
  },
];
